import { create } from 'zustand';
import { refreshToken as cfRefreshToken } from '@/lib/cloudflare/auth-client';

// Export the state type
export interface AuthState {
  isLoading: boolean;
  error: string | null;
}

interface AuthActions {
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  refreshToken: () => Promise<{ accessToken: string; expiresAt: number } | null>;
  reset: () => void;
}

export const useAuthStore = create<AuthState & AuthActions>()((set) => ({
  // State
  isLoading: false,
  error: null,

  // Actions
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  refreshToken: async () => {
    try {
      set({ isLoading: true, error: null });
      const result = await cfRefreshToken();
      return result;
    } catch (error) {
      set({ error: 'Failed to refresh token' });
      console.error('Token refresh failed:', error);
      return null;
    } finally {
      set({ isLoading: false });
    }
  },
  reset: () => set({ isLoading: false, error: null }),
})); 